import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { showTotal } from '../../Containers/commonFunctions';
// import AppConfig from '../../Config/AppConfig';
import ResizableAntdTable from "resizable-antd-table";

class BaseList extends Component {
  render() {
    return (
      <div style={{ padding: '0 10px 20px' }}>
        <ResizableAntdTable
         bordered={true}
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          dataSource={this.props.data}
          columns={this.columns}
          loading={this.props.dataLoadingStatus !== undefined?this.props.dataLoadingStatus:false}
          pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10','25', '50', '100'], total: this.props.data.length, showTotal: showTotal}}
          // pagination={this.props.pagination.position !== 'none' ? Object.assign({}, this.props.pagination, { pageSize: this.props.pagination.pageSize || AppConfig.perPage }) : { position: 'none', pageSize: 100 }}
          // pagination={Object.assign({}, this.props.pagination, { pageSize: this.props.pagination.pageSize || AppConfig.perPage })}
          size={this.props.size ? this.props.size : 'middle'}
          onChange={this.props.onTableChange}
          align='center'
          rowSelection={this.props.rowSelection ? Object.assign({}, this.props.rowSelection) : undefined}
        />
      </div>
    );
  }
}

BaseList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  pagination: PropTypes.shape(),
  onTableChange: PropTypes.func,
  bordered: PropTypes.bool,
  onDownload: PropTypes.func,
};

BaseList.defaultProps = {
  pagination: false,
  onTableChange: null,
  bordered: false,
  onDownload: null,
};

export default BaseList;
